import React from "react";
export default function About() {
  return (
    <div className="michroma-regular" style={{ textAlign: "center" }}>
      About
    </div>
  );
}
